/* eslint-disable array-callback-return */
 const formatDate = (date) => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [day, month, year].join('/');
}

export function formatISOWithLocalTime(date) {
    const offset = date.getTimezoneOffset() * 60000; // Offset em milissegundos
    const localDate = new Date(date.getTime() - offset); // Ajusta para o horário local

    // Formata para ISO, removendo a parte 'Z' que indica UTC
    const isoString = localDate.toISOString().slice(0, -1);

    return isoString;
}

export default formatDate;
